/**
 * Ant Design の Tree コンポーネントでチェックボックスを操作した際に、
 * 親ノードがチェックされた場合、全ての子ノードをチェックする処理を行う。
 * しかし、子ノードを選択しても親ノードはチェックされないようにする。
 *
 * @param {object} treeData
 * @param {array} checkedKeys
 * @param {object} info
 * @returns {array}
 */

export const getNewCheckedKeys = (treeData, checkedKeys, info) => {
  let newCheckedKeys = [...checkedKeys]

  // 親ノードがチェックされた場合、全ての子ノードをチェック
  if (info.node.children) {
    const childKeys = info.node.children.map((child) => child.key)
    if (info.checked) {
      newCheckedKeys = Array.from(new Set([...newCheckedKeys, ...childKeys]))
    } else {
      newCheckedKeys = newCheckedKeys.filter((key) => !childKeys.includes(key))
    }
  }

  // 親ノードのチェック状態は子ノードのチェック状態に影響されないようにする
  const parentKeys = treeData.map((node) => node.key)
  parentKeys.forEach((parentKey) => {
    const childKeys = treeData.find((node) => node.key === parentKey)?.children?.map((child) => child.key) || []
    const allChildrenChecked = childKeys.every((childKey) => newCheckedKeys.includes(childKey))

    if (!allChildrenChecked) {
      newCheckedKeys = newCheckedKeys.filter((key) => key !== parentKey)
    }
  })

  return newCheckedKeys
}
